<template>
  <div class="text-container">
    <el-tabs
      :tab-position="tabPosition"
      v-model="tabName"
      @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(item, ind) in tabList"
        :key="ind"
        :label="item.name"
        :name="item.id">
        <div class="box-container">
          <tab-content :ref="'tab' + item.id"></tab-content>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TabContent from './components/tabContent'
import { getAboutUs } from '@/api/aboutUs'
export default {
  name: 'aboutUs',
  components: {
    TabContent
  },
  data() {
    return {
      tabPosition: 'left',
      tabList: [
        { id: '2', name: '广电总局人才中心' },
        { id: '1', name: '新广汇贤公司介绍' },
        { id: '3', name: '人才培养计划' }
      ],
      tabName: ''
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  created() {
    if (this.id) {
      this.tabName = this.id
      this.handleTabClick({
        name: this.id
      })
    }
    // this.getList()
  },
  methods: {
    // 切换tab
    handleTabClick(e) {
      this.$router.push({ path: '/aboutUs', query: { id: e.name } })
      getAboutUs({
        id: e.name
      }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.$refs['tab' + e.name][0].init(data)
        }
      })
    }
    // 获取tab列表
    // getList() {
    //   getAboutUsListPage().then(res => {
    //     const { code, data } = res
    //     if (code === 0) {
    //       console.log('111', res, data)
    //       this.tabList = data.records
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  width: 1200px;
  margin: 0 auto 0;
  padding-top: 29px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ::v-deep .el-tabs {
    .el-tabs__nav-wrap::after, .el-tabs__active-bar {
      background-color: transparent;
    }
    .el-tabs__nav {
      width: 280px;
      // height: auto;
    }
    .el-tabs__item {
      height: 70px;
      line-height: 70px;
      font-size: 18px;
      font-weight: bold;
      color: #666;
      background-color: #fff;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #9BB9DE;
      &::before {
        content: '';
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        line-height: 70px;
        background-color: #9BB9DE;
        margin-right: 8px;
      }
    }
    .el-tabs__item.is-active {
      font-size: 20px;
      color: #fff;
      background-image: url('../../assets/image/tab-bg1.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      &::before {
        background-color: #FF4E4E;
      }
    }
    .el-tabs__item.is-left {
      text-align: left;
    }
    .box-container {
      width: 877px;
      max-width: 877px;
      background-color: #fff;
      height: auto;
      margin-left: 40px;
      box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
